import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import { strDateITAfromDayJs, strDateUSAfromDayJs, strDateITAfromStrUSA, strDateUSAfromStrITA } from '../../../utils/dateUtils.js'
const { strCurrency, strEuroCurrency } = require('../../../utils/currencyUtils.js')

const config = require("../../../constants/constants.js")

const EditMessagePageComponent = ({ updateMessageApiRequest, fetchMessage }) => {

  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState([]);
  const [updateMessageResponseState, setUpdateMessageResponseState] = useState({ message: "", error: "" });

  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [messageTxt, setMessageTxt] = useState("");
  const [note, setNote] = useState("");
  const [day, setDay] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    fetchMessage(id)
      .then(data => {
        console.log(`data =`, data);
        setTitle(data?.title);
        setEmail(data?.email);
        setTelephone(data?.telephone);
        setMessageTxt(data?.messageTxt);
        setNote(data?.note);
        setDay(data?.day);
        setTime(data?.time);
        console.log(`title  =`, title);
        console.log(`message =`, message);
      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
  }, [id])

  function salvaMessageModificata(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    console.log(`title dig =`, title);
    console.log(`email dig =`, email);
    console.log(`telephone dig =`, telephone);
    console.log(`messageTxt dig =`, messageTxt);

    updateMessageApiRequest(id, title, email, telephone, messageTxt, note, day, time)
      .then(data => {
        if (data.success === "message updated") {
          navigate("/admin/messages");
        }
      })
      .catch(er => {
        setUpdateMessageResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
      })

    window.location.assign('/admin/messages')
  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/messages')
  }


  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/messages">
              {config.BC_ADMIN_MESSAGES}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_MESSAGES_VIEW}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Dettagli messaggio</b>&nbsp;
            </Typography>

          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

            <Stack
              useFlexGap
              sx={{
                flexDirection: { xs: "column", md: "row" },
                paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                flexWrap: 'wrap'
              }}
            >

              <TextField id="id-cliente" label="Nome Cognome" variant="outlined" value={title} defaultValue={title}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setTitle(event.target.value);
                }}
              />

              <TextField id="id-email" label="Email" variant="outlined" value={email} defaultValue={email}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />

              <TextField id="id-telephone" label="Telefono" variant="outlined" value={telephone} defaultValue={telephone}
                sx={{
                  width: "20ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setTelephone(event.target.value);
                }}
              />

              <TextField id="id-messageTxt" label="Messaggio" variant="outlined" value={messageTxt} defaultValue={messageTxt}
                sx={{
                  width: "80ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                multiline
                rows={3}
                maxRows={6}
                onChange={(event) => {
                  setMessageTxt(event.target.value);
                }}
              />

              <TextField id="id-day" label="Data" variant="outlined" value={strDateITAfromStrUSA(day)} defaultValue={day}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setDay(event.target.value);
                }}
              />

              <TextField id="id-time" label="Ora" variant="outlined" value={time} defaultValue={time}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setTime(event.target.value);
                }}
              />

            </Stack>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: "row", md: "row" },
                alignItems: "center",
                justifyContent: "center"
              }}
            >

              <Button
                type="button"
                variant="contained"
                color="warning"
                onClick={(e) => { gotoIndietro(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Indietro
              </Button>

            </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>



    </Box>

  );
};

export default EditMessagePageComponent;
